export default __webpack_public_path__ + "static/media/feat-launch.ad3ce5a5.svg";